import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useDeleteNoteMutation } from "modules/notes/hooks/useDeleteNoteMutation"
import { useTranslation } from "react-i18next"

type Props = {
  noteId: string
  conversationId: string
  customerId?: string
  open: boolean
  onClose: () => void
}

export function DeleteNoteDialog({ noteId, conversationId, customerId, open, onClose }: Props) {
  const { t } = useTranslation()
  const { mutateAsync: deleteNote, isPending } = useDeleteNoteMutation()

  async function onConfirm() {
    await deleteNote({ id: noteId, conversationId, customerId })
    onClose()
  }

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("conversations.chat.notes.deleteNote")}</DialogTitle>
          <DialogDescription>
            {t("conversations.chat.notes.deleteNoteConfirmation")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" disabled={isPending}>
              <span>{t("shared.cancel")}</span>
            </Button>
          </DialogClose>
          <Button variant="destructive" onClick={onConfirm} disabled={isPending}>
            <span>{t("conversations.chat.notes.deleteNote")}</span>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
